export const createDefaultContent = (value: string = '', mode: string = 'json') => {
  return {
    value,
    mode,
  }
};
